/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { Suspense } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { SplashScreen } from "../features/SplashScreen";
import { Dashboard } from "../modules/dashboard/Dashboard";
import DishPage from "../modules/dish/DishPage";
import CouponPage from "../modules/coupon/CoponPage"; // Fixed typo here
import OrdersPage from "../modules/orders/OrdersPage";
import { Login } from "../auth/login/Login";
import ReportPage from "../modules/report/ReportPage";
import SettlementsPage from "../modules/settlements/SettlementsPage";
import SettingsPage from "../modules/settings/SettingsPage";
import Support from "../modules/support/files/Support";
import { Signup } from "../auth/signup/Signup";
import AddonPage from "../modules/addon/AddonPage";
import Help from "../modules/help/files/Help";
import SubscriptionPage from "../modules/subscription/SubscriptionPage";
import PaymentSuccess from "../modules/subscription/files/Success";
import PlanAccess from "../sidebar/PlanAccess";
import Header from "../sidebar/Header";
import Footer from "../sidebar/Footer";
import RefundPolicy from "../modules/policies/RefundPolicy";
import PrivacyPolicy from "../modules/policies/PrivacyPolicy";
import TermsAndConditions from "../modules/policies/TermsAndConditions";
import PaymentCancel from "../modules/subscription/files/Paymentcancel";
import SalesPage from "../modules/subscription/files/SalesPage";
import CategoryPage from "../modules/category/CategoryPage";
import IngredientPage from "../modules/incrediants/IngredientPage";
import SalesPagePromoteKit from "../modules/subscription/files/SalesPagePromoteKit";
import PromokitSuccess from "../modules/subscription/files/PromokitSuccess";
import PromokitCancel from "../modules/subscription/files/PromokitCancel";
import ChefReviewPage from "../modules/chef-review/ChefReviewPage";
import DishReviewPage from "../modules/dish-review/ReviewsPage";
import ListPlans from "../modules/subscription/files/ListSubscription";
import PlanUnsubscribe from "../modules/settings/files/listCompomponents/PlanUnsubscribe";
import PlanUnsubscribePage from "../modules/settings/files/listCompomponents/unsubscribeformobile";
const PrivateRoutes = () => {
  // Layout component to wrap common layout components like Header and Footer
  const Layout = () => {
    return (
      <>
        <Header />
        <Outlet />
        <Footer />
      </>
    );
  };

  return (
    <Suspense fallback={<SplashScreen />}>
      <Routes>
        {/* Redirect for unauthorized access */}
        <Route path="auth/*" element={<Navigate to="/signup" />} />

        {/* Define the layout route that wraps all private routes */}
        <Route element={<Layout />}>
          <Route path="dashboard/*" element={<Dashboard />} />
          <Route path="dish/*" element={<DishPage />} />
          <Route path="coupon/*" element={<CouponPage />} />
          <Route path="orders/*" element={<OrdersPage />} />
          <Route path="report/*" element={<ReportPage />} />
          <Route path="settlements/*" element={<SettlementsPage />} />
          <Route path="settings/*" element={<SettingsPage />} />
          <Route path="support/*" element={<Support />} />
          <Route path="help/*" element={<Help />} />
          <Route path="addons/*" element={<AddonPage />} />
          <Route path="dish-category/*" element={<CategoryPage />} />
          <Route path="ingredients/*" element={<IngredientPage />} />
          <Route path="subscription/*" element={<SubscriptionPage />} />
          <Route path="subscription/list/:id" element={<ListPlans/>} />
          <Route path="/subscription/unsubscribe/:chefId" element={<PlanUnsubscribePage />} />

          <Route path="access/*" element={<PlanAccess />} />
          <Route path="payment-success/*" element={<PaymentSuccess />} />
          <Route path="payment-cancel/*" element={<PaymentCancel />} />
          <Route path="refund-policy/*" element={<RefundPolicy />} />
          <Route path="privacy-policy/*" element={<PrivacyPolicy />} />
          <Route path="terms-conditions/*" element={<TermsAndConditions />} />
          <Route path="chef-review/*" element={<ChefReviewPage />} />
          <Route path="dish-review/*" element={<DishReviewPage />} />


        </Route>

        {/* Auth routes outside the private routes */}
        <Route path="login" element={<Login />} />
        <Route path="signup/*" element={<Signup />} />
        <Route path="sales-page/*" element={<SalesPage />} />
        <Route path="sales-page-promotekit/*" element={<SalesPagePromoteKit />} />
        <Route path="success-promotekit/*" element={<PromokitSuccess />} />
        <Route path="cancel-promotekit/*" element={<PromokitCancel />} />
      </Routes>
    </Suspense>
  );
};

export { PrivateRoutes };